import r, { useMemo as e } from "react";
import { useAuthenticator as s } from "@aws-amplify/ui-react-core";
import { ConfirmSignUp as i } from "../ConfirmSignUp/ConfirmSignUp.js";
import { ForceNewPassword as t } from "../ForceNewPassword/ForceNewPassword.js";
import { SetupTOTP as o } from "../SetupTOTP/SetupTOTP.js";
import "@aws-amplify/ui";
import "../../../primitives/TextField/TextField.js";
import "../../../primitives/Button/Button.js";
import "../../../primitives/Flex/Flex.js";
import "../../../primitives/Alert/Alert.js";
import { SignInSignUpTabs as n } from "../shared/SignInSignUpTabs.js";
import { ConfirmVerifyUser as a } from "../VerifyUser/ConfirmVerifyUser.js";
import { VerifyUser as m } from "../VerifyUser/VerifyUser.js";
import { ConfirmSignIn as p } from "../ConfirmSignIn/ConfirmSignIn.js";
import { ConfirmResetPassword as c } from "../ResetPassword/ConfirmResetPassword.js";
import { ResetPassword as f } from "../ResetPassword/ResetPassword.js";
import { isSignInOrSignUpRoute as u } from "../utils.js";
function d() {
  return null;
}
function l(_ref) {
  let {
    className: l,
    hideSignUp: w,
    variation: j
  } = _ref;
  const {
      route: U
    } = s(_ref2 => {
      let {
        route: r
      } = _ref2;
      return [r];
    }),
    g = e(() => (r => {
      switch (r) {
        case "authenticated":
        case "idle":
        case "setup":
        case "autoSignIn":
          return d;
        case "confirmSignUp":
          return i;
        case "confirmSignIn":
          return p;
        case "setupTOTP":
          return o;
        case "signIn":
        case "signUp":
          return n;
        case "forceNewPassword":
          return t;
        case "resetPassword":
          return f;
        case "confirmResetPassword":
          return c;
        case "verifyUser":
          return m;
        case "confirmVerifyUser":
          return a;
        default:
          return console.warn("Unhandled Authenticator route - please open an issue: ".concat(r)), d;
      }
    })(U), [U]);
  return r.createElement(g, {
    className: l,
    hideSignUp: u(U) ? w : void 0,
    variation: j
  });
}
export { l as Router };